import { createAction } from '@lifesize/typescript-react-redux-utils';
import { Actions } from 'constants/deviceManagementConstants';

const actions = {
  rebootDevice: (payload: string) =>
    createAction(Actions.REBOOT_DEVICE, payload),
  rebootDeviceSuccess: (payload: string) =>
    createAction(Actions.REBOOT_DEVICE_SUCCESS, payload),
  rebootDeviceFailure: (payload: string) =>
    createAction(Actions.REBOOT_DEVICE_FAILURE, payload),
  resetDevice: (payload: string) =>
    createAction(Actions.RESET_DEVICE, payload),
  resetDeviceSuccess: (payload: string) =>
    createAction(Actions.RESET_DEVICE_SUCCESS, payload),
  resetDeviceFailure: (payload: string) =>
    createAction(Actions.RESET_DEVICE_FAILURE, payload),
};

export default actions;
